module.exports = __webpack_public_path__ + "static/team-112f6b34559397c0a5bd20dc1e983202.jpg";